import "./AdxRuleComponent.scss";
import {IComponentOptions, IOnChanges, IOnChangesObject, IOnDestroy, IOnInit} from "angular";
import {AlertDialogAdxRule} from "../../models/AlertDialogAdxRule";
import {ComponentCallback} from "../../../../../types/AngularJS";
import {ReplaySubject} from "rxjs";
import {AdxAlertType} from "./models/AdxAlertType";
import {ObjectUtil} from "../../../../../js/util/ObjectUtil";
import {UnderlyingStatistics} from "../../../../models/UnderlyingStatistics";
import {RuleComponent} from "../RuleComponent";

export const AdxRule = "tfAdxAlertRule";

export function adxRule(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/adx/AdxRuleComponent.html`,
        require: {
            ruleList: "^^tfAlertRuleList"
        },
        bindings: {
            rule: "<",
            statistics: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: AdxRuleComponentController
    };
}

export class AdxRuleComponentController extends RuleComponent implements IOnInit, IOnChanges, IOnDestroy {

    public readonly rule: AlertDialogAdxRule;
    public readonly statistics: UnderlyingStatistics;
    public readonly onChange: ComponentCallback;

    public type = AdxAlertType.ABOVE;
    public adxAbove: number | null = null;
    public adxBelow: number | null = null;
    public adxLowerThanCurrent = false;
    public adxHigherThanCurrent = false;

    private readonly changed$ = new ReplaySubject<boolean>(1);
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        super.$onInit();
        this.changed$
            .takeUntil(this.destroyed$)
            .debounceTime(100)
            .map(() => this.buildRule())
            .subscribe((rule) => this.onChange({$rule: rule}));
    }

    private buildRule(): AlertDialogAdxRule {
        const copy = ObjectUtil.copy(this.rule);
        copy.adxType = this.type;
        copy.adxAbove = this.adxAbove;
        copy.adxBelow = this.adxBelow;
        return copy;
    }

    public $onChanges(changes: IOnChangesObject): void {
        if (changes.rule != null && this.rule != null) {
            this.type = this.currentRuleType(this.rule);
            this.updateValues(this.rule);
        }
    }

    private currentRuleType(rule: AlertDialogAdxRule): AdxAlertType {
        if (rule.adxType != null) {
            return rule.adxType;
        } else if (rule.adxBelow != null) {
            return AdxAlertType.BELOW;
        } else {
            return AdxAlertType.ABOVE;
        }
    }

    private updateValues(rule: AlertDialogAdxRule) {
        this.adxAbove = rule.adxAbove;
        this.adxBelow = rule.adxBelow;
    }

    public changeType(type: AdxAlertType) {
        this.type = type;
        this.ruleChanged();
    }

    public ruleChanged() {
        this.changed$.next(true);
        this.adxHigherThanCurrent = this.isHigherThanCurrentADX();
        this.adxLowerThanCurrent = this.isLowerThanCurrentADX();
    }

    public get wouldTriggerImmediately(): boolean {
        return this.isHigherThanCurrentADX() || this.isLowerThanCurrentADX();
    }

    private isLowerThanCurrentADX(): boolean {
        const currentADX = this.statistics.adx;
        if (this.type === AdxAlertType.ABOVE &&
            this.adxAbove! < currentADX) {
            return true;
        }

        return false;
    }

    private isHigherThanCurrentADX(): boolean {
        const currentADX = this.statistics.adx;
        if (this.type === AdxAlertType.BELOW &&
            this.adxBelow! > currentADX) {
            return true;
        }

        return false;
    }

    public $onDestroy(): void {
        super.$onDestroy();
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
